import { vpnManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import axios, { isAxiosError } from "axios";

export const getVPNSupportSessionsById = async (
  namespace: string,
  sessionId: string,
) => {
  const url = vpnManagerUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get(
      `${url}/api/v2/ns/${namespace}/support-sessions/${sessionId}`,
      {
        headers: headers,
      },
    );
    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw err;
    } else {
      throw new Error(
        "An unexpected error occurred while fetching support session by ID.",
      );
    }
  }
};
